/**
 * @deprecated We should never be using this on web.
 */
export function setTopLevelNavigator() {
  return;
}

export function getCurrentRouteName(): string {
  return window.location.pathname;
}

/**
 * @deprecated We should never be using this on web.
 */
export function getCurrentRouteNames(): string[] {
  return [];
}

export function goBack() {
  return;
}

export function navigate(location: Record<string, unknown>) {
  return location;
}
